<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="auth-wrapper">
  <div class="auth-container">
    <!-- Lado Esquerdo -->
    <div class="auth-side-left">
      <div class="auth-content-left">
        <img src="assets/images/logoIGTI.png" alt="E-Cidadania" class="logo-img">
        <div class="welcome-text">
          <h1>Mentoria que Conecta</h1>
          <div class="mentoria-buttons" style="margin: 1.5rem 0 1rem 0; display: flex; flex-direction: column; gap: 0.75rem; align-items: center;">
            <button class="mentoria-btn">Quero ser mentorado</button>
            <button class="mentoria-btn">Mentorado</button>
            <button class="mentoria-btn">Mentor</button>
          </div>
         
        </div>
      </div>
    </div>

    <!-- Lado Direito -->
    <div class="auth-side-right">
      <div class="auth-content-right">

        <h2>Login</h2>
        <form class="login-form">
          <div class="form-group">
            <div class="input-icon">
              <i class="feather icon-mail"></i>
              <input type="email" class="form-control" [(ngModel)]="email" name="email" placeholder="Seu e-mail">
            </div>
          </div>
          <div class="form-group">
            <div class="input-icon">
              <i class="feather icon-lock"></i>
              <input type="password" class="form-control" [(ngModel)]="senha" name="senha" placeholder="Sua senha">
            </div>
          </div>
          <button type="button" class="btn-login" (click)="login()">Entrar</button>
          <button type="button" class="btn-login btn-outline" style="margin-top: 10px; background: white; color: #153658; border: 2px solid #153658;" (click)="irParaCadastro()">Cadastrar</button>
        </form>
      </div>
    </div>
  </div>
</div>

<style>
.auth-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.auth-container {
  display: flex;
  width: 100%;
  max-width: 1200px;
  min-height: 600px;
  margin: 2rem;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
}

.auth-side-left {
  flex: 1;
  /* Gradiente: verde claro e roxo claro */
  background: linear-gradient(135deg, #6ee7b7 0%, #c4b5fd 100%);
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.auth-side-left::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" fill="rgba(255,255,255,0.05)"/></svg>');
  opacity: 0.5;
}

.auth-content-left {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
}

.logo-img {
  width: 180px;
  margin-bottom: 2rem;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
}

.welcome-text h1 {
  font-size: 2.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: #ffffff;
}

.welcome-text p {
  font-size: 1.1rem;
  opacity: 0.9;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
  color: #ffffff;
}

.auth-side-right {
  flex: 1;
  background: white;
  padding: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-content-right {
  width: 100%;
  max-width: 400px;
}

.logo-horizontal {
  width: 200px;
  margin-bottom: 2rem;
}

.auth-content-right h2 {
  font-size: 2rem;
  color: #153658;
  margin-bottom: 2rem;
  font-weight: 600;
}

.form-group {
  margin-bottom: 1.5rem;
}

.input-icon {
  position: relative;
}

.input-icon i {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #153658;
  opacity: 0.7;
}

.form-control {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #153658;
  box-shadow: 0 0 0 3px rgba(21, 54, 88, 0.1);
  outline: none;
}

.btn-login {
  width: 100%;
  padding: 12px;
  background: #B75ECF; /* Roxo personalizado */
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-login:hover {
  background: #6ee7b7; /* Verde claro no hover */
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(110, 231, 183, 0.2);
}

.btn-login.btn-outline {
  margin-top: 10px;
  background: white;
  color: #6ee7b7;
  border: 2px solid #6ee7b7;
}

.btn-login.btn-outline:hover {
  background: #6ee7b7;
  color: white;
  border: 2px solid #6ee7b7;
}

@media (max-width: 991.98px) {
  .auth-container {
    flex-direction: column;
    margin: 1rem;
    min-height: auto;
  }

  .auth-side-left {
    padding: 2rem;
    min-height: 300px;
  }

  .auth-side-right {
    padding: 2rem;
  }

  .logo-img {
    width: 140px;
  }

  .welcome-text h1 {
    font-size: 2rem;
  }
}

@media (max-width: 575.98px) {
  .auth-container {
    margin: 0;
    border-radius: 0;
  }

  .auth-side-left,
  .auth-side-right {
    padding: 1.5rem;
  }

  .logo-img {
    width: 120px;
  }

  .welcome-text h1 {
    font-size: 1.75rem;
  }
}

.mentoria-buttons {
  margin: 1.5rem 0 1rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  align-items: center;
  width: 100%;
}
.mentoria-btn {
  background: #B75ECF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
  margin: 0.15rem 0;
  width: 100%;
  max-width: 320px;
  box-sizing: border-box;
  display: block;
}
.mentoria-btn:hover {
  background: #6ee7b7;
  color: #153658;
}
</style>
  